import { render, staticRenderFns } from "./HelpCenterGettingStartedNavItem.vue?vue&type=template&id=2936780e&scoped=true&"
import script from "./HelpCenterGettingStartedNavItem.vue?vue&type=script&lang=js&"
export * from "./HelpCenterGettingStartedNavItem.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterGettingStartedNavItem.vue?vue&type=style&index=0&id=2936780e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936780e",
  null
  
)

export default component.exports